<template>
  <popup :close-action="emitCloseEvent" class="apple-promotion-non-payer-popup" :buttons="buttons">
    <template v-slot:title>
      <div class="ri-medium-bold-headline padding-top-sm">
        אפשר לממש את ההטבה דרך החשבון של {{ payingMemberName }}
      </div>
    </template>
    <template v-slot:content>
      <div class="ri-body padding-top-xs padding-bottom-ml">
        כיוון שהמינוי נוצר על ידי {{ payingMemberName }}
        , כדי לממש את ההטבה צריך לבקש מ{{ payingMemberName }} להיכנס לאפליקציה ממכשיר האייפון, ובעמוד ״הגדרות מינוי״ לבחור ״למימוש ההטבה״
      </div>
    </template>
  </popup>
</template>

<script>
import BenefitMixin from '@/pages/responsive-pages/authenticated/subscription/V2/BenefitMixin.vue';
import BaseUI from '@riseupil/base-ui';
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'ApplePromotionNonPayerPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  mixins: [
    BenefitMixin,
  ],
  methods: {
    emitCloseEvent() {
      this.$emit('close');
    },
    sendWAMessageToPayingMember() {
      const WALinkWithPhoneNumber = `https://wa.me/${this.payingMemberPhone}?text=${this.getShareActionText}`;
      window.open(WALinkWithPhoneNumber, '_blank');
    },
  },
  computed: {
    ...mapState('session', ['members']),
    ...mapGetters('subscription', ['payingMemberId']),
    payingMember() {
      return _.find(this.members, { _id: this.payingMemberId });
    },
    payingMemberName() {
      return this.payingMember ? this.payingMember.firstNamePiiValue : '';
    },
    payingMemberPhone() {
      return this.payingMember ? this.payingMember.phoneNumberPiiValue : '';
    },
    getShareActionText() {
      const transactionLink = `${window.location.origin}/account-settings`;
      return `היי,
%0A
קיבלנו הטבה של ${this.monthString} חינם ברייזאפ. צריך להיכנס לאפליקציה של רייזאפ כדי לממש אותה. זה לוקח דקה:
%0A
${transactionLink}
`;
    },
    buttons() {
      return [{
        title: 'הבנתי',
        action: this.emitCloseEvent,
      },
      {
        title: `לשלוח ל${this.payingMemberName} הודעה`,
        action: () => this.sendWAMessageToPayingMember(),
        variant: 'secondary',
      }];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.apple-promotion-non-payer-popup {
  text-align: center;
  .popup {
    padding-bottom: 0;
  }
}
</style>
